import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useIntercom } from "react-use-intercom";

import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";

import { useLogout } from "../../CustomHooks/Mutations";

import { getNavItems, isActiveModule, onSignOut } from "../../Utils/helpers";

import { StakeLogo } from "../../Assets/Images";
import { Support, Logout } from "../../Assets/Icons";

export default function SideBar() {
  const { pathname } = useLocation();

  const {
    appUtilityProps: { hideDealsRoutes },
  } = useAppUtilityContext();

  const navItems = useMemo(() => getNavItems({ hideDealsRoutes }), [hideDealsRoutes]);

  const { show: showIntercom } = useIntercom();

  const { mutate: InitLogout } = useLogout({
    onSettled: onSignOut,
  });

  return (
    <div className="app-utility-sidebar">
      <StakeLogo className="logo dark-with-accentuated-horn" />
      <div className="sidebar-nav">
        {navItems.map(({ Icon, navItemName, navRoute }, idx) => (
          <Link
            key={idx}
            className={`sidebar-nav-item${isActiveModule(navRoute, pathname) ? " active" : ""}`}
            to={navRoute}
          >
            <Icon className="nav-icon" />
            {navItemName}
          </Link>
        ))}
        <span className="spacer"></span>
        <button className="sidebar-nav-item" onClick={showIntercom}>
          <Support className="nav-icon" />
          Support
        </button>
        <button className="sidebar-nav-item" onClick={InitLogout}>
          <Logout className="nav-icon" />
          Logout
        </button>
      </div>
    </div>
  );
}
